module.exports = __webpack_public_path__ + "static/media/drugs.e2170706.png";